// src/pages/Notifications.jsx
import React, { useState } from "react";

export default function Notifications() {
  const [notifications, setNotifications] = useState([
    { id: 1, text: "Leave request from Priya Patel", time: "2h ago", read: false },
    { id: 2, text: "Interview scheduled: Frontend Developer", time: "1d ago", read: true },
    { id: 3, text: "Payroll processed for September", time: "3d ago", read: true },
  ]);

  const markAllRead = () => setNotifications((n) => n.map(x => ({...x, read: true})));

  return (
    <div className="p-6 max-w-3xl">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">Notifications</h1>
        <button onClick={markAllRead} className="px-3 py-2 border rounded">Mark all read</button>
      </div>

      <div className="bg-white rounded-xl shadow border divide-y">
        {notifications.map(n => (
          <div key={n.id} className={`p-4 ${n.read ? "bg-white" : "bg-blue-50"}`}>
            <div className="flex justify-between items-start">
              <p className="text-sm">{n.text}</p>
              <span className="text-xs text-gray-400">{n.time}</span>
            </div>
          </div>
        ))}
        {notifications.length === 0 && <div className="p-6 text-center text-gray-500">No notifications</div>}
      </div>
    </div>
  );
}
